import React from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {PostModel} from './BlogModels'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'

interface BlogCardProps {
  post: PostModel
}

const BlogCard: React.FC<BlogCardProps> = ({post}) => {
  const navigate = useNavigate()

  const handleCategoryClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    navigate(`/blog/category/${post.category?.slug}`)
  }

  return (
    <div className='card h-100 blog-card-modern'>
      <Link to={`/blog/${post.slug}`} style={{textDecoration: 'none', color: 'inherit'}}>
        <img
          src={toAbsoluteUrl(post.image)}
          alt={post.title}
          className='card-img-top blog-card-image'
        />
        <div className='card-body'>
          <h5 className='card-title mb-2'>{post.title}</h5>
          <div
            className='d-flex justify-content-between align-items-center mb-2'
            style={{fontSize: '0.9rem'}}
          >
            {post.category && (
              <button
                type='button'
                className='badge bg-light-primary text-primary fw-bold d-flex align-items-center border-0'
                style={{textDecoration: 'none', background: 'transparent', cursor: 'pointer'}}
                onClick={handleCategoryClick}
              >
                <KTIcon iconName='tag' className='fs-5 ms-1' />
                {post.category.name}
              </button>
            )}
            <span className='text-muted d-flex align-items-center'>
              <KTIcon iconName='calendar' className='fs-5 ms-1' />
              {new Date(post.created_at).toLocaleDateString('fa-IR')}
            </span>
          </div>
        </div>
      </Link>
    </div>
  )
}

export {BlogCard}
